import { render } from "./InputSearchTermText.vue?vue&type=template&id=c0f5854a&scoped=true"
import script from "./InputSearchTermText.vue?vue&type=script&lang=js"
export * from "./InputSearchTermText.vue?vue&type=script&lang=js"

import "./InputSearchTermText.vue?vue&type=style&index=0&id=c0f5854a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f5854a"]])

export default __exports__